module.exports = __webpack_public_path__ + "static/flags/KE-56e337104e4662c12302f2adaa10695f.gif";